module.exports = __webpack_public_path__ + "static/media/justify_left.6ec32415.png";